import { lazyToggleActivityPane } from 'mini-activity-pane-store';
import { LOAD_ACTIVITY_PANE } from 'mini-mail-workflow-tracking/lib/constants/ActivityPaneWorkflowConstants';
import { signalWorkflowEvent } from 'mini-workflow-manager';

export const onActivityIconClick = () => {
    lazyToggleActivityPane.importAndExecute();
    signalWorkflowEvent(LOAD_ACTIVITY_PANE);
};
